var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71094 18.3333V17.2917C2.71094 16.3341 2.89954 15.3859 3.26598 14.5013C3.63242 13.6166 4.16952 12.8128 4.84662 12.1357C5.52371 11.4586 6.32754 10.9215 7.2122 10.555C8.09687 10.1886 9.04505 10 10.0026 10C10.9602 10 11.9083 10.1886 12.793 10.555C13.6777 10.9215 14.4815 11.4586 15.1586 12.1357C15.8357 12.8128 16.3728 13.6166 16.7392 14.5013C17.1057 15.3859 17.2943 16.3341 17.2943 17.2917V18.3333",
    stroke: "#A7B3C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0026 9.99935C11.1077 9.99935 12.1675 9.56036 12.9489 8.77896C13.7303 7.99756 14.1693 6.93775 14.1693 5.83268C14.1693 4.72761 13.7303 3.66781 12.9489 2.8864C12.1675 2.105 11.1077 1.66602 10.0026 1.66602C8.89754 1.66602 7.83773 2.105 7.05633 2.8864C6.27492 3.66781 5.83594 4.72761 5.83594 5.83268C5.83594 6.93775 6.27492 7.99756 7.05633 8.77896C7.83773 9.56036 8.89754 9.99935 10.0026 9.99935V9.99935Z",
    stroke: "#A7B3C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileicon);
export default __webpack_public_path__ + "static/media/Profileicon.aa2d6e2700c9c5263a3cb5f378ce3490.svg";
export { ForwardRef as ReactComponent };